import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element.classList.contains("alert-success")) {
      setTimeout(() => {
        this.element.classList.remove("show");
        this.element.addEventListener(
          "transitionend",
          () => {
            this.element.remove();
          },
          { once: true }
        );
      }, 1000);
    }
  }
}
